import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";

type MeterReaderDetailProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  detail: Record<string, any>;
};

const MeterReaderDetail: React.FC<MeterReaderDetailProps> = ({
  open,
  onOpenChange,
  detail,
}) => {
  const file = detail?.file;
  const isImage = file instanceof File
    ? file.type.startsWith("image/")
    : typeof file === "string" && file.match(/\.(jpeg|jpg|png|gif|bmp)$/i);

  const filePreviewUrl =
    file instanceof File ? URL.createObjectURL(file) : file;

  const remainingFields = [
    { name: "employeeId", label: "Employee ID" },
    { name: "city", label: "City" },
    { name: "contactNumber", label: "Phone Number" },
    { name: "joiningDate", label: "Joining Date" },
    { name: "imeiNo", label: "IMEI Number" },
    { name: "version", label: "Version" },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Meter Reader Details</DialogTitle>
        </DialogHeader>

        {/* Summary Card */}
        <div className="flex items-start gap-6 bg-muted/20 p-4 rounded-lg mb-4 border-b">
          {file && isImage && (
            <img
              src={filePreviewUrl}
              alt="Uploaded"
              className="w-20 h-20 object-cover rounded border"
            />
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
            <div>
              <div className="text-xs text-muted-foreground">Name</div>
              <div className="text-sm font-medium">
                {detail?.name ?? "-"}
              </div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground">Email</div>
              <div className="text-sm font-medium">
                {detail?.email ?? "-"}
              </div>
            </div>
            <div className="sm:col-span-2">
              <div className="text-xs text-muted-foreground">Address</div>
              <div className="text-sm font-medium">
                {detail?.address ?? "-"}
              </div>
            </div>
          </div>
        </div>

        {/* Remaining Fields */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-8 pl-4">
          {remainingFields.map(({ name, label }) => (
            <div key={name}>
              <div className="text-xs text-muted-foreground">{label}</div>
              <div className="text-sm text-foreground break-words">
                {detail?.[name] ?? "-"}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MeterReaderDetail;
